import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { JobNotificationCenter } from "./components/JobNotificationCenter";
import CharacterSwitch from "./pages/CharacterSwitch";
import Chat from "./pages/Chat";
import GoogleLinkPopup from "./pages/GoogleLinkPopup";
import GoogleOAuthPopupComplete from "./pages/GoogleOAuthPopupComplete";
import GroupTalkHub from "./pages/GroupTalkHub";
import GroupTalkPreview from "./pages/GroupTalkPreview";
import GroupTalkSessionList from "./pages/GroupTalkSessionList";
import GroupTalkSession from "./pages/GroupTalkSession";
import Home from "./pages/Home";
import LineLinkPopup from "./pages/LineLinkPopup";
import NewsGoogleReconsentComplete from "./pages/NewsGoogleReconsentComplete";
import EmailInviteOnboarding from "./pages/EmailInviteOnboarding";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import ProfileSettings from "./pages/ProfileSettings";
import ReceiptPopup from "./pages/ReceiptPopup";
import RequestEntry from "./pages/RequestEntry";
import RequestNewsPage from "./pages/RequestNewsPage";
import RequestReportPage from "./pages/RequestReportPage";
import Splash from "./pages/Splash";
import TalkEntry from "./pages/TalkEntry";

const IS_STAGING = process.env.REACT_APP_ENV === "staging";
const PUBLIC_LANDING_PAGE_PATH = "/landing";

export default function App() {
  return (
    <BrowserRouter>
      {IS_STAGING && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            height: "24px",
            background: "#f97316",
            color: "#fff",
            fontSize: "11px",
            fontWeight: "bold",
            letterSpacing: "0.1em",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          STAGING
        </div>
      )}
      <JobNotificationCenter />
      <Routes>
        <Route path="/" element={<Navigate to="/splash" replace />} />
        <Route path={PUBLIC_LANDING_PAGE_PATH} element={<LandingPage />} />
        <Route path="/splash" element={<Splash />} />
        <Route path="/onboarding" element={<EmailInviteOnboarding />} />
        <Route path="/home" element={<Home />} />
        <Route path="/profile" element={<ProfileSettings />} />
        <Route path="/character-switch" element={<CharacterSwitch />} />
        <Route path="/talk" element={<TalkEntry />} />
        <Route path="/talk/group" element={<GroupTalkHub />} />
        <Route path="/talk/group/preview" element={<GroupTalkPreview />} />
        <Route path="/talk/group/sessions" element={<GroupTalkSessionList />} />
        <Route path="/talk/group/sessions/:sessionId" element={<GroupTalkSession />} />
        <Route path="/request" element={<RequestEntry />} />
        <Route path="/request/news" element={<RequestNewsPage />} />
        <Route path="/request/report" element={<RequestReportPage />} />
        <Route path="/receipt" element={<ReceiptPopup />} />
        <Route path="/google-link" element={<GoogleLinkPopup />} />
        <Route path="/google-link/complete" element={<GoogleOAuthPopupComplete />} />
        <Route path="/news/google-consent/complete" element={<NewsGoogleReconsentComplete />} />
        <Route path="/line-link" element={<LineLinkPopup />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="*" element={<Navigate to="/splash" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
